/**
 * Collection cards: metafield product tiles — sync variant, price, and main image on the card.
 * On phone (≤740px, same breakpoint as theme + yodeyma-product-variant-tiles.css), also opens the
 * native quick-buy popover so shoppers get full variant selection, quantity, and OZ swatches.
 *
 * Breakpoint source of truth: window.themeVariables.breakpoints.phone (snippets/js-variables.liquid).
 * Do not use (hover: none) / (pointer: coarse) to choose popover vs inline — that CSS only toggles
 * .product-item__quick-form visibility, not #product-item-quick-buy-popover vs drawer.
 *
 * Quick-buy: theme openable-element fetches getAttribute("href"). We set href then open=true on
 * <quick-buy-popover id="product-item-quick-buy-popover">, same contract as toggle-button.
 *
 * Toggle: Theme settings → Related Products Swatches → “On mobile, open quick buy when tapping
 * a product tile” (oz_swatches_tile_tap_opens_quick_buy_phone → themeVariables.settings.ozSwatchesTileTapOpensQuickBuyPhone).
 */
(function () {
  if (!window.themeVariables) return;

  var QUICK_BUY_POPOVER_ID = 'product-item-quick-buy-popover';
  var VIEW_POPOVER = 'quick-buy-popover';

  function isPhoneQuickBuyViewport() {
    var bp = window.themeVariables.breakpoints && window.themeVariables.breakpoints.phone;
    if (bp) return window.matchMedia(bp).matches;
    return window.matchMedia('screen and (max-width: 740px)').matches;
  }

  /**
   * @param {string} productUrl - data-product-url; often relative; may include query or #hash
   * @param {string} viewSuffix - e.g. quick-buy-popover
   * @param {string} [variantId] - tile data-variant-id for pre-selected variant in quick-buy
   * @returns {string|null} path + search + hash for href (same-origin fetch), or null if invalid
   */
  function buildQuickBuyProductUrl(productUrl, viewSuffix, variantId) {
    if (!productUrl || typeof productUrl !== 'string') return null;
    try {
      var u = new URL(String(productUrl).trim(), window.location.origin);
      u.searchParams.set('view', viewSuffix);
      if (variantId) u.searchParams.set('variant', String(variantId));
      return u.pathname + u.search + u.hash;
    } catch (e) {
      return null;
    }
  }

  function openGlobalQuickBuyPopover(productUrl, variantId) {
    var href = buildQuickBuyProductUrl(productUrl, VIEW_POPOVER, variantId);
    if (!href) return false;
    var el = document.getElementById(QUICK_BUY_POPOVER_ID);
    if (!el || typeof el.setAttribute !== 'function') return false;
    el.setAttribute('href', href);
    el.open = true;
    return true;
  }

  function setActiveTile(list, tile) {
    if (!list) return;
    list.querySelectorAll('.oz-product-tiles__tile--selectable').forEach(function (btn) {
      var on = btn === tile;
      btn.classList.toggle('is-active', on);
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
  }

  /** YODEYMA_MARKET_TAX — same rules as theme bundle (separators + moneyWithoutTrailingZeros) */
  function shopifyFormatMoney(cents, format) {
    var s = window.themeVariables && window.themeVariables.settings;
    format =
      format || (s && s.currencyCodeEnabled ? s.moneyWithCurrencyFormat : s.moneyFormat);
    if (typeof window.yodeymaMarketTaxFormatMoney === 'function') {
      try {
        return window.yodeymaMarketTaxFormatMoney(cents, format);
      } catch (e1) {}
    }
    if (typeof Shopify !== 'undefined' && typeof Shopify.formatMoney === 'function') {
      return Shopify.formatMoney(cents, format);
    }
    if (!format || !s) {
      var code = (s && s.cartCurrency) || 'EUR';
      try {
        return new Intl.NumberFormat(document.documentElement.lang || undefined, {
          style: 'currency',
          currency: code,
        }).format(cents / 100);
      } catch (e2) {
        return (cents / 100).toFixed(2);
      }
    }
    var placeholder = /\{\{\s*(\w+)\s*\}\}/;
    var match = format.match(placeholder);
    if (!match) return String(cents / 100);

    function formatWithDelimiters(number, precision, thousands, decimal) {
      thousands = thousands || ',';
      decimal = decimal || '.';
      if (isNaN(number) || number == null) return '0';
      var str = (number / 100).toFixed(precision);
      var parts = str.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsPart = parts[1] ? decimal + parts[1] : '';
      return dollars + centsPart;
    }

    var value = '';
    switch (match[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
      case 'amount_with_apostrophe_separator':
        value = formatWithDelimiters(cents, 2, "'");
        break;
      default:
        value = formatWithDelimiters(cents, 2);
    }
    return format.replace(placeholder, value);
  }

  function updateCardPrice(card, priceCents, compareAtCents) {
    var s = window.themeVariables.settings;
    var format = s.currencyCodeEnabled ? s.moneyWithCurrencyFormat : s.moneyFormat;
    var priceList = card.querySelector('product-price-list[data-product-price-list]');
    if (!priceList) return;

    var main = priceList.querySelector('span.price.price--large');
    var compareWrap = priceList.querySelector('.price-list__compare-container');
    var compareSpan = compareWrap && compareWrap.querySelector('.price.price--compare');
    var onSale = compareAtCents > priceCents;

    if (main) {
      main.textContent = shopifyFormatMoney(priceCents, format);
      main.classList.toggle('price--highlight', onSale);
    }

    if (onSale && compareWrap && compareSpan) {
      compareSpan.textContent = shopifyFormatMoney(compareAtCents, format);
      compareWrap.hidden = false;
      compareWrap.style.removeProperty('display');
    } else if (compareWrap) {
      compareWrap.hidden = true;
      compareWrap.style.display = 'none';
    }
  }

  function updateCardImage(card, tile) {
    var src = tile.dataset.imageSrc;
    if (!src) return;

    var anchor = card.querySelector('[data-yodeyma-image-anchor]');
    if (!anchor) return;

    var flickityRoot = anchor.querySelector('flickity-carousel');
    var img;
    if (flickityRoot) {
      img =
        flickityRoot.querySelector('.slide-media-content-wrapper.is-selected img') ||
        flickityRoot.querySelector('.slide-media-content-wrapper:first-child img') ||
        flickityRoot.querySelector('.flickity-slider > *:first-child img') ||
        flickityRoot.querySelector('img');
    } else {
      img =
        anchor.querySelector('img.product-item__primary-image') || anchor.querySelector('img');
    }
    if (!img) return;

    img.src = src;
    if (tile.dataset.imageSrcset) img.srcset = tile.dataset.imageSrcset;
    else img.removeAttribute('srcset');
    if (tile.dataset.imageSizes) img.sizes = tile.dataset.imageSizes;
  }

  function syncFormVariant(card, tile, variantId) {
    var form = card.querySelector('form[is="product-form"]');
    if (!form) return;
    var idInput = form.querySelector('input[name="id"]');
    if (idInput && variantId) idInput.value = String(variantId);

    var pid = tile && tile.dataset && tile.dataset.productId;
    if (pid) {
      var pidInput = form.querySelector('input[name="product-id"]');
      if (!pidInput) {
        pidInput = document.createElement('input');
        pidInput.type = 'hidden';
        pidInput.name = 'product-id';
        form.appendChild(pidInput);
      }
      pidInput.value = String(pid);
    }

    var h = tile && tile.dataset && tile.dataset.handle;
    if (h) {
      form.setAttribute('handle', String(h));
    }
  }

  document.addEventListener(
    'click',
    function (e) {
      var tile = e.target.closest('.oz-product-tiles__tile--selectable');
      if (!tile || tile.disabled) return;

      var interactiveRoot = tile.closest('[data-yodeyma-tile-interactive]');
      if (!interactiveRoot) return;

      var card = tile.closest('[data-yodeyma-tile-sync]') || tile.closest('product-item');
      if (!card) return;

      e.preventDefault();

      var list = tile.closest('.oz-product-tiles__list');
      setActiveTile(list, tile);

      var priceCents = parseInt(tile.dataset.priceCents, 10);
      var compareAtCents = parseInt(tile.dataset.compareAtCents || '0', 10);
      if (!isNaN(priceCents)) {
        updateCardPrice(card, priceCents, isNaN(compareAtCents) ? 0 : compareAtCents);
      }

      updateCardImage(card, tile);

      var vid = tile.dataset.variantId;
      if (vid) syncFormVariant(card, tile, vid);

      var settings = window.themeVariables.settings || {};
      var openQuickBuyOnPhoneTap = settings.ozSwatchesTileTapOpensQuickBuyPhone !== false;
      if (openQuickBuyOnPhoneTap && isPhoneQuickBuyViewport()) {
        var productUrl = tile.dataset.productUrl;
        if (productUrl) openGlobalQuickBuyPopover(productUrl, vid);
      }
    },
    false
  );
})();
